<template>
    <div class="simulation">
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'

    export default {
        name: 'Simulation',
        computed : {
            ...mapGetters([
                'simComplete',
                'isCurrentActionSubmitted'
            ])
        }
    }
</script>

<style lang="scss" scoped></style>
